import useResponsibleForm, { IResponsibleForm } from '../../hooks/useResponsibleForm';
import { DrawerSvccCargando } from '../../../../components/drawer/DrawerSvcc';
import {
    DrawerSvccCuerpo,
    DrawerSvccEncabezado,
    DrawerSvccPie,
    DrawerSvccSeccion
} from '../../../../components/drawer/DrawerSvcc';
import CamposSvcc from '../../../../components/drawer/CamposSvcc';

/** Secciones del drawer, por `name` de la configuración de campos. */
const SECCIONES = [
    { clave: 'datosPersonales', nombres: ['name', 'surname', 'cuit'] },
    { clave: 'cargo', nombres: ['charge', 'respresentation', 'status', 'hoursQuantity'] },
    {
        clave: 'habilitacion',
        nombres: ['habilitationTitle', 'otherHabilitationTitle', 'licenceNumber', 'grantingEntity']
    }
];

const ResponsibleForm = ({ handleCloseDrawer, selected, isEditing, onlyVisual }: any) => {
    const responsibleForm = useResponsibleForm({
        selectedResponsible: selected,
        isEditing: isEditing,
        handleCloseDrawer: handleCloseDrawer
    });
    const {
        formData,
        responsibleFieldsConfig,
        errors,
        isAddingResponsible,
        isEditingResponsible,
        handleChange,
        translate,
        handleSubmit
    } = responsibleForm;

    return (
        <>
            <DrawerSvccEncabezado
                titulo={translate(
                    `responsiblesAndContractorsForms.newResponsible.titles.${
                        isEditing ? 'edit' : 'new'
                    }`
                )}
                paso={translate('responsiblesAndContractorsForms.drawerPaso')}
                onCerrar={handleCloseDrawer}
            />
            <DrawerSvccCuerpo>
                {SECCIONES.map(({ clave, nombres }) => (
                    <DrawerSvccSeccion
                        key={clave}
                        titulo={translate(
                            `responsiblesAndContractorsForms.newResponsible.secciones.${clave}`
                        )}
                    >
                        <CamposSvcc
                            config={responsibleFieldsConfig}
                            nombres={nombres}
                            formData={formData as IResponsibleForm & Record<string, any>}
                            errors={errors}
                            onChange={handleChange}
                            onlyVisual={onlyVisual}
                        />
                    </DrawerSvccSeccion>
                ))}
            </DrawerSvccCuerpo>
            <DrawerSvccPie
                onCancelar={handleCloseDrawer}
                onConfirmar={handleSubmit}
                textoCancelar={translate('responsiblesAndContractorsForms.buttons.cancel')}
                textoConfirmar={translate('responsiblesAndContractorsForms.buttons.save')}
                nota={
                    onlyVisual
                        ? undefined
                        : translate('responsiblesAndContractorsForms.camposObligatorios')
                }
                cargando={isAddingResponsible || isEditingResponsible}
                sinConfirmar={onlyVisual}
            />
            <DrawerSvccCargando cargando={isAddingResponsible || isEditingResponsible} />
        </>
    );
};

export { ResponsibleForm };
